export default "__VITE_ASSET__BsuoXx6n__"